module.exports = __webpack_public_path__ + "img/kds-img.a301dab1.svg";